module.exports = __webpack_public_path__ + "img/icon-qt.531196b0.png";